import { render } from "./HorseChart.vue?vue&type=template&id=e82312aa&scoped=true"
import script from "./HorseChart.vue?vue&type=script&lang=js"
export * from "./HorseChart.vue?vue&type=script&lang=js"

import "./HorseChart.vue?vue&type=style&index=0&id=e82312aa&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e82312aa"]])

export default __exports__